<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                allowClear
                placeholder="搜索关键字"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select
                v-model="queryParam.status"
                placeholder="请选择"
                allowClear
              >
                <a-select-option value="1">审核成功</a-select-option>
                <a-select-option value="2">等待审核</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="省市">
              <a-cascader
                :options="areaOptions"
                placeholder="请选择地区"
                v-model="queryParam.namekeys"
                changeOnSelect
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="等级">
              <a-select
                v-model="queryParam.grade"
                placeholder="请选择"
                allowClear
              >
                <a-select-option value="三">三级</a-select-option>
                <a-select-option value="二">二级</a-select-option>
                <a-select-option value="一">一级</a-select-option>
                <a-select-option value="国家">国家级</a-select-option>
                <a-select-option value="国际">国际级</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-item label="注册时间">
              <a-range-picker
                v-model="time_range_moment"
                style="width: 100%"
                format="YYYY-MM-DD"
                :showTime="{
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }"
              />
            </a-form-item>
          </a-col>

          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button @click="download(1)">
        导出
        <a-icon type="download" />
      </a-button>
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="danwei" slot-scope="text, record">
        <div style="margin-left: 10px; float: left">
          {{ record.name }} ({{ record.code }})
          <br />
          {{ record.num }}
          <br />
          注册时间 {{ record.regist_date | timeFormat }}
          <br />
          <span style="color: #999"
            >{{ record.province }}{{ record.city }}{{ record.county }}</span
          >
        </div>
      </span>
      <span slot="grade" slot-scope="text, record">
        <p v-show="record.code > 0">
          <a-tag>{{ record.code }}</a-tag>
        </p>
        <p v-if="record.wudaograde">{{ record.wudaograde }}级</p>
        <!--        <p v-if="record.jiqiaograde">{{ record.jiqiaograde }}级</p>-->
      </span>
      <span slot="status" slot-scope="text, record">
        <a-tag v-if="record.status == 1" color="green">审核成功</a-tag>
        <a-tag v-else-if="record.status == 2" color="red">待审核</a-tag>
        <a-tag v-else-if="record.status == 3">审核失败</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" v-if="record.status == 1" />
          <a-popconfirm
            v-if="record.status == 1"
            title="确定删除吗"
            @confirm="handleDelete(record)"
            okText="确定"
            cancelText="取消"
          >
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider v-if="record.cert_url" type="vertical" />
          <a v-if="record.cert_url" @click="downloadCert(record)">下载证书</a>
          <a-divider v-if="record.cert_url" type="vertical" />
          <a-popconfirm
            title="确定重新生成证书吗?"
            @confirm="refreshCert(record)"
            okText="确定"
            cancelText="取消"
          >
            <a v-if="record.cert_url" href="javascript:;">重新生成证书</a>
          </a-popconfirm>
          <a-divider v-if="record.status == 1" type="vertical" />
          <a v-if="record.status == 1" @click="handlePrint(record)">打印单号</a>
          <a-divider type="vertical" />
          <a  @click="handlePici(record)">批次管理</a>
        </template>
      </span>
    </s-table>

    <a-modal
      title="操作"
      :width="1200"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="姓名"
                hasFeedback
              >
                <a-input v-model="formData.name" placeholder="请输入名称" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="身份证号"
                hasFeedback
              >
                <a-input v-model="formData.num" placeholder="请输入身份证号" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="手机号"
                hasFeedback
              >
                <a-input v-model="formData.phone" placeholder="请输入手机号" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="微信号"
                hasFeedback
              >
                <a-input v-model="formData.weixin" placeholder="请输入微信号" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="邮箱"
                hasFeedback
              >
                <a-input v-model="formData.email" placeholder="请输入邮箱" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="等级"
                hasFeedback
              >
                <a-select
                  v-model="formData.wudaograde"
                  placeholder="请选择等级"
                  allowClear
                >
                  <a-select-option value="三">三级</a-select-option>
                  <a-select-option value="二">二级</a-select-option>
                  <a-select-option value="一">一级</a-select-option>
                  <a-select-option value="国家">国家级</a-select-option>
                  <a-select-option value="国际">国际级</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="证书号"
                hasFeedback
              >
                <a-input v-model="formData.code" placeholder="请输入证书号" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="注册时间"
                hasFeedback
              >
                <a-date-picker
                  style="width: 100%"
                  v-model="formData.regist_date"
                  format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleOk"
          >保存</a-button
        >
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import JiaolianPicker from "@/components/JiaolianPicker/";
import CaipanPicker from "@/components/CaipanPicker/";
import areaOptions from "@/utils/area";
import moment from "moment";
import qs from "qs";
import setting from "@/config/setting";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

import {
  getMemberList,
  refreshCert,
  editShengCaipan,
  getShengCaipanDetail,
  shengCaipanPrint,
  deleteShengCp,
} from "@/api/caipan";

export default {
  name: "KaojiApplyList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    EditableCell,
    CaipanPicker,
    JiaolianPicker,
  },
  data() {
    return {
      areaOptions,
      visible: false,
      orderVisible: false,
      saveLoading: false,
      userFormVisible: false,
      jiaolianPickerShow: false,
      caipanPickerShow: false,
      sjsqOptions: [],
      orderFormData: {},
      formData: {
        id: 0,
        danwei: "",
        areas: [],
        member_list: [],
        loglist: [],
      },
      time_range_moment: [],
      time_range: [],
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
        sjsq: [],
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "人员信息",
          dataIndex: "danwei",
          scopedSlots: { customRender: "danwei" },
        },
        {
          title: "等级",
          dataIndex: "grade",
          scopedSlots: { customRender: "grade" },
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 240,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 表头
      subjectColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "姓名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "电话",
          dataIndex: "phone",
        },
        {
          title: "微信",
          dataIndex: "weixin",
        },
        {
          title: "套餐",
          dataIndex: "service",
          scopedSlots: { customRender: "service" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 120,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        if (this.time_range_moment[0] && this.time_range_moment[1]) {
          this.queryParam.time_range = [
            this.time_range_moment[0].format("YYYY-MM-DD HH:mm:ss"),
            this.time_range_moment[1].format("YYYY-MM-DD HH:mm:ss"),
          ];
        } else {
          this.queryParam.time_range = [];
        }

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getMemberList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: "",
        price: 0,
        note: "",
        count: 0,
      },
      serviceTypeOptions: [],
      userFormData: {
        id: 0,
        name: "",
        caipandengjiwudao: "",
        caipandengjijiqiao: "",
        jiaoliandengjiwudao: "",
        jiaoliandengjijiqiao: "",
        caipanshenbaowudao: "",
        caipanshenbaojiqiao: "",
        jiaolianshenbaowudao: "",
        jiaolianshenbaojiqiao: "",
      },
    };
  },
  computed: {},

  created() {},

  mounted() {
    let that = this;

    let query = this.$route.query;
    // 6, 276
    console.log(query);
    if (query.saiji) {
      this.queryParam.sjsq = [query.saiji, query.saiqu];
    }
    // that.getSjsqOptions();
  },
  methods: {
    moment,
    getSjsqOptions() {
      let that = this;
      sjsqOptions({}).then((res) => {
        that.sjsqOptions = res.data;
      });
    },
    handlePici(record) {
        let { href } = this.$router.resolve({ name: 'ShengCaipanManage', query: { id: record.shengcpid } })
        window.open(href, '_blank')
    },
    handleCancel() {
      this.visible = false;
    },
    handleOrderCancel() {
      this.orderVisible = false;
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    handlePrint(record) {
      let self = this;
      shengCaipanPrint({ id: record.id })
        .then((res) => {
          self.$message.success("打印成功");
        })
        .catch((err) => {
          console.log(err);
          self.$message.error(err.data.msg);
        });
    },

    handleEdit(record) {
      let self = this;
      this.visible = true;
      getShengCaipanDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
          self.formData.id = record.id;
          console.log("handleEdit");
          // if(res.data.area){
          //   res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
          // }else{
          //   res.data.areas = [];
          // }
          res.data.regist_date = moment(res.data.regist_date * 1000).format(
            "YYYY-MM-DD HH:mm:ss"
          );
          res.data.regist_date = moment(res.data.regist_date, "YYYY-MM-DD");
          self.formData = { ...res.data };
        }, 200);
      });
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.formData);
          self.saveLoading = true;
          editShengCaipan({
            id: self.formData.id,
            name: self.formData.name,
            weixin: self.formData.weixin,
            email: self.formData.email,
            num: self.formData.num,
            phone: self.formData.phone,
            code: self.formData.code,
            regist_date: parseInt(
              moment(self.formData.regist_date).valueOf() / 1000
            ),
            wudaograde: self.formData.wudaograde,
          })
            .then((res) => {
              self.$message.success("修改成功");
              self.$refs.table.refresh(false);
              self.visible = false;
              self.saveLoading = false;
            })
            .catch((err) => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            });
        }
      });
    },
    // 增改 处理
    handleOrderOk(e) {
      let self = this;
      e.preventDefault();

      self.saveLoading = true;
      editShengCaipanOrder({
        id: self.orderFormData.id,
        baoming_id: self.orderFormData.baoming_id,
        status: self.orderFormData.status,
        adminnote: self.orderFormData.adminnote,
        memberprice: self.orderFormData.memberprice,
        pay_price: self.orderFormData.pay_price,
      })
        .then((res) => {
          self.$message.success("修改成功");
          self.$refs.table.refresh(false);
          self.orderVisible = false;
          self.saveLoading = false;
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
          self.saveLoading = false;
        });
    },

    handleDelete(record) {
      let that = this;
      deleteShengCp({
        id: record.id,
      })
        .then((res) => {
          that.$message.success("删除成功");
          that.$refs.table.refresh(false);
        })
        .catch((err) => {
          that.$message.error(err.data.msg);
        });
    },

    // 删
    applyDelete(record) {
      let self = this;
      applyDelete({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    // 删
    applyDeleteAll() {
      let self = this;
      applyDelete({ ids: self.selectedRowKeys, id: 0 })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh();
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    onEditUser(record) {
      let self = this;
      this.userFormVisible = true;
      getApplyUserDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form3.setFieldsValue({ ...res.data });
          self.userFormData.id = record.id;
          self.userFormData = { ...res.data };
        }, 200);
      });
      getServiceTypeList({ saiqu: self.formData.saiqu }).then((res) => {
        setTimeout(() => {
          self.serviceTypeOptions = res.data;
        }, 200);
      });
    },
    handleUserFormCancel() {
      this.userFormVisible = false;
    },

    handleUserFormOk(e) {
      let self = this;
      e.preventDefault();
      this.form3.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.userFormData);
          self.saveLoading = true;
          editShengCaipanUser({
            id: self.userFormData.id,
            name: values.name,
            num: values.num,
            phone: values.phone,
            sex: values.sex,
            service_id: self.userFormData.service_id,
            caipandengjiwudao: self.userFormData.caipandengjiwudao,
            caipandengjijiqiao: self.userFormData.caipandengjijiqiao,
            jiaoliandengjiwudao: self.userFormData.jiaoliandengjiwudao,
            jiaoliandengjijiqiao: self.userFormData.jiaoliandengjijiqiao,
            caipanshenbaowudao: self.userFormData.caipanshenbaowudao,
            caipanshenbaojiqiao: self.userFormData.caipanshenbaojiqiao,
            jiaolianshenbaowudao: self.userFormData.jiaolianshenbaowudao,
            jiaolianshenbaojiqiao: self.userFormData.jiaolianshenbaojiqiao,
          })
            .then((res) => {
              self.$message.success("修改成功");
              self.userFormVisible = false;
              self.saveLoading = false;
            })
            .catch((err) => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            });
        }
      });
    },

    download(type) {
      console.log("this.queryParam");
      console.log(this.queryParam);
      // if (typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length != 2) {
      // this.$message.error('请先选择赛区');
      // return;
      // }
      switch (type) {
        case 1:
          window.open(
            setting.apiBaseURL +
              "/adminapi/caipan/shengCpDownload?" +
              qs.stringify(this.queryParam)
          );
          break;
      }
    },
    downloadCert(record) {
      window.open(setting.apiBaseURL + "" + record.cert_url);
    },
    refreshCert(record) {
      const hide = this.$message.loading("生成中..", 0);
      refreshCert({ id: record.id }).then((res) => {
        this.$message.success("证书生成成功");
        setTimeout(hide, 0);
      });
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
  },
  filters: {},
  watch: {},
};
</script>
